
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#FFA69D","width":"20","height":"20","rx":"10"}}),_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M4 4h12v12H4z"}}),_c('path',{attrs:{"d":"M8.82 4.935a1.81 1.81 0 012.353 0l.476.406a.795.795 0 00.475.197l.626.046c.893.07 1.589.766 1.659 1.658l.046.627a.825.825 0 00.197.475l.406.475a1.77 1.77 0 01-.012 2.354l-.406.476a.795.795 0 00-.197.475l-.046.626a1.793 1.793 0 01-1.658 1.659l-.626.046a.825.825 0 00-.476.197l-.475.406c-.337.29-.754.44-1.171.44-.418 0-.835-.15-1.172-.44l-.475-.406a.795.795 0 00-.475-.197l-.627-.046a1.793 1.793 0 01-1.658-1.659l-.046-.626a.825.825 0 00-.197-.475l-.406-.476a1.81 1.81 0 010-2.354l.406-.475a.795.795 0 00.197-.475l.046-.627a1.793 1.793 0 011.658-1.658l.627-.046a.825.825 0 00.475-.197zm1.17.533a.811.811 0 00-.544.197l-.476.406c-.29.255-.65.394-1.032.43l-.626.046a.833.833 0 00-.765.765l-.047.626a1.787 1.787 0 01-.429 1.032l-.406.476a.842.842 0 000 1.09l.406.475c.255.29.394.65.43 1.032l.046.626c.034.406.348.73.765.766l.626.046c.383.035.742.174 1.032.429l.476.406a.842.842 0 001.09 0l.475-.406c.29-.255.65-.394 1.032-.43l.626-.045a.833.833 0 00.766-.766l.046-.626c.035-.383.174-.742.429-1.032l.406-.475a.816.816 0 000-1.09l-.406-.476a1.787 1.787 0 01-.43-1.032l-.045-.626a.833.833 0 00-.766-.765l-.626-.047a1.787 1.787 0 01-1.032-.429l-.475-.406a.874.874 0 00-.545-.197zm1.578 5.276a.823.823 0 110 1.647.823.823 0 010-1.647zm-.22-2.794a.49.49 0 01.683 0 .48.48 0 01.012.684L8.645 12.03a.511.511 0 01-.347.14.491.491 0 01-.348-.14.49.49 0 010-.684zm-2.934-.36a.823.823 0 110 1.647.823.823 0 010-1.647z","fill":"#001C45"}})])])
          )
        }
      }
    